/* istanbul ignore file */ /* this file is not used or will be deleted in other branches */
// @ts-nocheck
import React, { Fragment } from 'react';
import useFieldApi from '@data-driven-forms/react-form-renderer/dist/cjs/use-field-api';
import { formatters } from '../../utils';

export const GridCell = (props) => {
  const { input } = useFieldApi(props);
  const formatter = formatters[props.component];

  const value =
    (formatter
      ? formatter({ value: input.value, options: props.options })
      : Array.isArray(input.value)
      ? undefined
      : input.value) || '---';

  return (
    <Fragment>
      {props.useFlex ? (
        <div className='px-4 py-2 leading-8 truncate' style={{ width: props.colWidth }} title={value}>
          {value}
        </div>
      ) : (
        <td className='px-4 py-2 truncate' title={value}>
          {value}
        </td>
      )}
    </Fragment>
  );
};
